<template>
  <div>
    <v-overlay :value="openPopup">
      <v-card color="#fff" width="290">
        <v-card-text class="card-text-styling">
          {{ message }}
        </v-card-text>
        <v-card-text class="card-sub-text-styling" v-if="subtitle">
          {{ subtitle }}
        </v-card-text>
        <v-divider style="background-color: rgba(33, 33, 33, 0.08); margin-bottom: 30px" />
        <div class="action-btn-styling">
          <Button
            v-if="leftBtnLabel"
            :label="leftBtnLabel"
            @click="$emit('leftBtnClick')"
            :outlined="true"
            buttonColor="#fff"
            fontColor="#000"
            class="btn-styling"
          />
          <Button
            v-if="rightBtnLabel"
            :label="rightBtnLabel"
            @click="$emit('rightBtnClick')"
            :outlined="false"
            buttonColor="#128279"
            fontColor="#fff"
            class="btn-styling"
          />
        </div>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import Button from './button.vue'
export default {
  name: 'CustomPopup',
  props: {
    openPopup: {
      type: Boolean,
      default: false
    },
    leftBtnLabel: {
      type: String,
      default: ''
    },
    rightBtnLabel: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  components: {
    Button
  }
}
</script>

<style scoped>
.card-text-styling {
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 16px !important;
  text-align: center !important;
}
.card-sub-text-styling {
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 16px !important;
  text-align: center !important;
  margin-top: -15px;
}

.action-btn-styling {
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
  padding-bottom: 20px;
}

.btn-styling {
  width: 120px !important;
}
</style>
